import { logError } from 'calling-cross-tab-library/utils/logError';
import CrossTabConfig from '../calling-cross-tab-utils/CrossTabConfig';
export function validatePortMessage(messageEvent) {
  if (!messageEvent || !messageEvent.data) {
    logError(new Error('message event does not have a data attribute'), {
      extra: {
        messageEventType: messageEvent.type
      }
    });
    return false;
  }
  if (!messageEvent.data.destinationConnectionId) {
    return true;
  }
  const data = messageEvent.data;
  const {
    connectionId
  } = CrossTabConfig.get();
  return connectionId === data.destinationConnectionId;
}